import { Injectable } from '@angular/core';
import { globals } from '../globals';
import { HttpClient, HttpParams } from '@angular/common/http';
import { FreteFaixa } from '../models/frete-faixa';
import { PrecificacaoUF } from '../models/precificacao-uf';
import { TipoPrecificacao } from '../models/enum';

@Injectable({
  providedIn: 'root'
})
export class PrecificacaoUFService {
  constructor(private http: HttpClient) { }

  salvar(precificacao: PrecificacaoUF) {
    return this.http.post(globals.apiUrl + '/api/PrecificacaoUF/Salvar', precificacao);
  }

  consultarPorUF(uf) {
    return this.http.get<any>(globals.apiUrl + '/api/PrecificacaoUF/Buscar',
      { params: new HttpParams().set('uf', uf) });
  }

  consultar() {
    return this.http.get<PrecificacaoUF[]>(globals.apiUrl + '/api/PrecificacaoUF/Lista');
  }

  consultarComPaginacao(descri, paginaAtual, qtdRegistros, campoOrdenacao, asc_desc, tipoDa?) {

    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', asc_desc)
      .set('descri', descri ? descri : '');

    if (tipoDa != null && tipoDa != undefined) {
      parametros = parametros.set('da', tipoDa);
    }

    return this.http.get<any>(globals.apiUrl + '/api/PrecificacaoUF/ListaPag',
      {
        params: parametros
      });
  }

  excluir(uf) {
    return this.http.delete(globals.apiUrl + '/api/PrecificacaoUF/Excluir',
      { params: new HttpParams().set('uf', uf) });
  }

  calcularPrecificacaoUF(valor: number, precificacaoUF: PrecificacaoUF) {

    if (precificacaoUF === null || precificacaoUF === undefined) {
      return valor;
    }

    return precificacaoUF.tipoDa === 0 ?
      (Number((valor
        - ((valor * precificacaoUF.percentual) / 100)).toFixed(2))) :
      (Number((valor
        + ((valor * precificacaoUF.percentual) / 100)).toFixed(2)));
  }

  calcularPrecificacaoIntegrador(valor: number, valorBase: number, tipoPrecificacao: TipoPrecificacao, valorPrecificacao: number) {

    if (valorPrecificacao === 0) {
      return valor;
    }

    return tipoPrecificacao === TipoPrecificacao.Desconto ?
      (Number((valor
        - ((valorBase * valorPrecificacao) / 100)).toFixed(2))) :
      (Number((valor
        + ((valorBase * valorPrecificacao) / 100)).toFixed(2)));
  }

  calcularPrecoBase(resultado: number, precificacaoUF: PrecificacaoUF, tipoPrecificacao: TipoPrecificacao, valorPrecificacao: number): number {

    // Fator da UF
    const fatorUF = (precificacaoUF === null || precificacaoUF === undefined)
      ? 1
      : precificacaoUF.tipoDa === 0
        ? 1 - precificacaoUF.percentual / 100
        : 1 + precificacaoUF.percentual / 100;

    // Fator do integrador
    const fatorIntegrador = valorPrecificacao === 0
      ? 0
      : tipoPrecificacao === TipoPrecificacao.Desconto
        ? -(valorPrecificacao / 100)
        : +(valorPrecificacao / 100);

    const fatorTotal = fatorUF + fatorIntegrador;

    return Number((resultado / fatorTotal).toFixed(2));
  }
}
